import { useState } from "react";
const useFormValidation = (values:any):any => {

    const errors:any = {};
    const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    const regexPhone = /^(\+\d{1,3}[- ]?)?\d{10}$/;
    const RegexNum = /^[0-9]*$/;
    if (!values.email) {
      errors.email = "Email is required!";
    } else if (!regexEmail.test(values.email)){
      errors.email = "This is not a valid email format!";
    }
    if (!values.name) {
        errors.name = "Name is required!";
      } else if(values.name.length < 4){
        errors.name = "Must be at least 4 alphabets!";
      }
    if (!values.phone){
        errors.phone = "Phone number is required!";
      } 
      else if (!RegexNum.test(values.phone)){
        errors.phone = "This is not a valid mobile number!";
      }
       else if (values.phone.length > 11 || values.phone.length < 11 ){
        errors.phone = "Must be 11 digits!";
      }
      if (!values.advert) {
        errors.advert = "You must select an option!";
      } 

    return errors;
  };

  export default useFormValidation